import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { Store } from '../../store';

@Injectable()
export class AuthenticationGuard  {
  constructor(
    private authService: MsalService,
    private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    // Prefer the account MSAL itself considers active; only fall back to
    // getAllAccounts()[0] if none is set yet. Unconditionally taking
    // getAllAccounts()[0] can resolve a stale/wrong account after a cache
    // inconsistency (e.g. multiple accounts, or a leftover entry from a
    // previous session) — this mirrors the fix that stabilized the same
    // login flow in the ContentRocket app.
    const account = this.authService.instance.getActiveAccount()
      ?? this.authService.instance.getAllAccounts()[0];

    if (account) {
      if (!this.authService.instance.getActiveAccount()) {
        this.authService.instance.setActiveAccount(account);
      }
      if (account.idTokenClaims) {
        Store.role = account.idTokenClaims?.roles;
      } else {
        console.log("no user roles")
        this.router.navigate(['authentication/login']);
        return false;
      }
      return true;
    }
    else {
      this.router.navigate(['authentication/login']);
      return false;
    }
  }
}